<div class="dialog-container" *ngIf = "!loader; else skeletonLoader">
  <ng-container *ngIf="popupIndex === 0">
    <img (click)="showAll ? changePopupIndex(1) : cancel()" [src]="images.CLOSE_TRANSPARENT" class="cross-transparent"
      [alt]="'EE_VALUE.CLOSE' | fallbackTranslate" />
    <div class="advertisement flex flex_column align-items-start">
      <div *ngIf="showAll" (click)="changePopupIndex(1)"
        class="flex-center gap-2 back-to-leaderboard top-6 fw-500 fs-20">
        <img [src]="images.WHITE_BACK_ARROW" alt="Scan Qr Ad" />
        Back to Leaderboard
      </div>
      <div class="scan-n-win-intro">
        <img [src]="images.SCAN_QR_AD" alt="Scan Qr Ad" class="scan-n-win-intro-img" />
        <!-- <div (click)="changePopupIndex(3)" class="terms-and-condition">Terms and Conditions</div> -->
      </div>  
    </div>
  </ng-container>

  <ng-container *ngIf="popupIndex === 1">
    <img (click)="cancel()" [src]="images.CLOSE_TRANSPARENT" class="cross-transparent"
      [alt]="'EE_VALUE.CLOSE' | fallbackTranslate" />
    <div class="flex qr-leaderboard">
      <div class="leaderboard-info flex_column">
        <div class="info-top flex-center flex_column lh-normal">
          <div class="fs-25 fw-600 clr-333">Score Board</div>
          <div class="flex-center flex_column">
            <img [src]="images.SCAN_N_WIN" alt="Scan Qr Ad" class="scan-n-win-img"/>
            <div class="fs-40 fw-700 clr-333">QR Challenge</div>
          </div>
          <!-- <div class="flex-center gap-2 any-doubt fw-600" (click)="changePopupIndex(0)">
            <img [src]="images.INFO_TRANSPARENT" alt="Scan Qr Ad" />
            What is Scan & Win?
          </div> -->
          <div class="flex-center gap-3 m-t-10">
          <img [src]="images.SCAN_N_WINPRIZE" alt="Scan Win Prize" class="scan-n-win-prize" /> </div>      
        </div>
        <div [ngClass]="inEligibilityReason ? 'm-t-10' : 'm-t-40'" class="info-bottom flex-center flex_column gap-3">
          <div class="flex-center flex_column gap-4">
            <div class="fs-16 clr-333">Winners will be announced every day</div>
            <div (click)="changePopupIndex(3)" class="terms-and-condition">Terms and Conditions</div>
            <!-- <div class="fs-25 fw-700">{{ countdown }}</div> -->
          </div>
          <!-- <div  *ngIf="inEligibilityReason" class="flex-center leader-info">
            <div class="robot"><img [src]="images.SCAN_N_WINROBO" alt="Scan Win Robot" /> </div>
            <div class="m-l-5">{{inEligibilityReason}}</div>
          </div> -->
          <!-- <div class="fs-16">Want to improve your rank?
            <span class="fw-700 text-underline" (click)="changePopupIndex(2)">
              Click Here
            </span>
          </div> -->
        </div>
      </div>
      <div class="leaderboard-rank flex flex_column gap-2">
        <div class="table-head flex fs-14 gap-3">
          <div class="th-title-1">Rank</div>
          <div class="th-title-2">Name</div>
          <div class="th-title-3 ta_right">QR %</div>
        </div>
        <div class="spinner-container flex-center" *ngIf="loading">
          <ng-template #indicatorTemplate><i nz-icon nzType="loading"></i></ng-template>
          <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
        </div>
        <ng-container *ngIf="!loading">
          <ng-container *ngFor="let item of scanNWinData">
            <div class="table-data flex flex-center gap-3" [ngClass]="{
              'your-rank': item.RESTAURANT_ID === rest_id
            }">
              <div class="rank-number flex-center fs-20 fw-600" [ngClass]="{
                'rank-1': item.RANK_LATEST === 1,
                'rank-2': item.rank_latest === 2,
                'rank-3': item.rank_latest === 3
              }">
                <img *ngIf="item.RANK_LATEST <= 1" [src]="images.QR_RANK" alt="Scan Qr Ad" />
                <div *ngIf="item.RANK_LATEST > 1">
                  {{item.RANK_LATEST}}
                </div>
              </div>
              <div class="res-info">
                <div class="fs-18 fw-600 res-name">
                  {{item.RESTAURANT_ID === rest_id ? 'You' : replaceEvenCharsWithX(item.RESTAURANT_NAME)}}
                </div>
                <div class="fs-14 res-add">{{item.CITY}} {{item.STATE}}</div>
              </div>
              <div class="fs-20 fw-700 flex-center res-qr">{{item.QR_ADOPTION}}%</div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      
    </div>
    <div (click)="changePopupIndex(4)" class="flex_sb view-prev-winners">
      <div>Check out our winners from the previous challenge</div>  
      <div class="fw-700">
        View List <img [src]="images.SCAN_N_WIN_RIGHT_ARROW" alt="Right Arrow" />
      </div>  
    </div>
  </ng-container>

  <ng-container *ngIf="popupIndex === 2">
    <img (click)="changePopupIndex(1)" [src]="images.CLOSE_TRANSPARENT" class="cross-transparent"
      [alt]="'EE_VALUE.CLOSE' | fallbackTranslate" />
    <div class="flex flex_column how-to-improve align-items-start">
      <div (click)="changePopupIndex(1)" class="flex-center gap-2 back-to-leaderboard fw-500 fs-20">
        <img [src]="images.WHITE_BACK_ARROW" alt="Scan Qr Ad" />
        Back to Leaderboard
      </div>
      <div class="flex flex_column info-containter">
        <div class="hti-header fw-700 fs-18">How to improve rank</div>
        <div class="hti-points fs-20">
          <ul class="flex flex_column gap-3">
            <li>QR Adoption is: out of all orders, how many were received using EasyEat QR? For example: If you received
              a total of 10 orders in a day, and out of those 5 orders were recorded via EasyEat QR, then the QR
              Adoption is 50%.</li>
            <li>Ask more and more of your customers to place their orders via EasyEat QR</li>
            <li>Ask your restaurant staff to promote QR ordering</li>
            <li>Take more and more payments via EasyEat application</li>
          </ul>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="popupIndex === 3">
    <img (click)="changePopupIndex(0)" [src]="images.CLOSE_TRANSPARENT" class="cross-transparent"
      [alt]="'EE_VALUE.CLOSE' | fallbackTranslate" />
    <div class="flex flex_column how-to-improve align-items-start">
      <div (click)="changePopupIndex(0)" class="flex-center gap-2 back-to-leaderboard fw-500 fs-20">
        <img [src]="images.WHITE_BACK_ARROW" alt="Scan Qr Ad" />
        Back to Advertisement
      </div>
      <!-- <div class="flex flex_column info-containter">
        <div class="hti-header fw-700 fs-18">Terms and Conditions</div>
        <div class="hti-points fs-20">
          <ul class="flex flex_column gap-3">
            <li>QR Adoption will be considered for Dine-In orders only</li>
            <li>⁠Failing to record at least 10 Dine-In orders per day will put you at the last spot in the leaderboard
            </li>
            <li>Failing to record orders for at least 8 out of 9 days of the challenge will put you at the last spot in
              the leaderboard</li>
            <li>⁠Any taxes on the prize money will be borne by the receiver</li>
            <li>⁠Rewards will be handed over in the form of cash to the receiver within 10 days of the declaration of
              the results</li>
          </ul>
        </div>
      </div> -->
      <div class="scan-n-win-tnc">
        <img [src]="images.SCAN_N_WIN_TNC" alt="tnc" class="scan-n-win-tnc-img" />
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="popupIndex === 4">
    <img (click)="showOnlyWinner ? cancel() : changePopupIndex(0)" [src]="images.CLOSE_TRANSPARENT" class="cross-transparent"
      [alt]="'EE_VALUE.CLOSE' | fallbackTranslate" />
    <div class="flex flex_column how-to-improve align-items-start">
      <div *ngIf="!showOnlyWinner" (click)="changePopupIndex(0)" class="back-to-leaderboard fw-500 fs-20">
        <img [src]="images.WHITE_BACK_ARROW" alt="Scan Qr Ad"  />
        Back
      </div>
      <div class="flex flex_column" (click)="showOnlyWinner ? null : changePopupIndex(0)">
         <img [src]="showOnlyWinner ? images.SCAN_N_WIN_CURRENT_WINNER : images.SCAN_N_WIN_PREV_WINNER" [alt]="showOnlyWinner ? 'current winner' :'previous winner'" class="prev-winner">
      </div>
    </div>
  </ng-container>

</div>

<ng-template #skeletonLoader>
  <nz-skeleton [nzActive]="true"></nz-skeleton>
</ng-template>
